// blog data
export const Blogs = [
    {
        id:1,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
    {
        id:2,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
    {
        id:3,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
    {
        id:4,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
   
   
    {
        id:5,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
   
    {
        id:6,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
   
    {
        id:7,
        name:"React Portfolio",
        tags:["react","gsjavascriptap","styled-components"],
        date:"13 May, 2022",
        link:"https://iammohitwalia.github.io/Portfolio/"
    },
   
   
] 